import { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import Button from "../ui/button";
import { disableAnalytics, trackPageView } from "../../lib/analytics";
import { OPEN_SETTINGS_EVENT, readConsent, writeConsent } from "../../lib/consent";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);
  const { pathname, search } = useLocation();

  useEffect(() => {
    if (readConsent() === null) setVisible(true);
  }, []);

  useEffect(() => {
    const reopen = () => setVisible(true);
    window.addEventListener(OPEN_SETTINGS_EVENT, reopen);
    return () => window.removeEventListener(OPEN_SETTINGS_EVENT, reopen);
  }, []);

  const accept = useCallback(() => {
    writeConsent(true);
    setVisible(false);
    // The visit that produced the consent is itself a page view.
    trackPageView(`${pathname}${search}`);
  }, [pathname, search]);

  const reject = useCallback(() => {
    writeConsent(false);
    disableAnalytics();
    setVisible(false);
  }, []);

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-labelledby="cookie-consent-title"
      aria-describedby="cookie-consent-description"
      className="fixed inset-x-0 bottom-0 z-50 p-4 sm:p-6"
    >
      <div className="mx-auto max-w-3xl rounded-lg border border-paper-300 bg-paper p-5 shadow-brand-card sm:p-6">
        <h2
          id="cookie-consent-title"
          className="font-display text-base font-semibold tracking-tight text-ink"
        >
          Cookies
        </h2>

        <p
          id="cookie-consent-description"
          className="mt-2 text-sm leading-relaxed text-ink-muted"
        >
          We’d like to set analytics cookies to understand how this site is
          used. Nothing is set unless you accept.{" "}
          <a
            href="/cookies"
            className="font-medium text-brand-600 underline underline-offset-2 hover:text-brand-700"
          >
            How we handle data
          </a>
        </p>

        <div className="mt-5 flex flex-col gap-2.5 sm:flex-row">
          <Button onClick={accept} className="sm:flex-1">
            Accept
          </Button>
          <Button variant="outline" onClick={reject} className="sm:flex-1">
            Decline
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
